import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const imgs = {
  article: {
    img: "https://photo.8891.com.tw/2024/06/18/1718678880181783.png",
    title: "下載App 隨時隨地看資訊",
  },
  picture: {
    img: "https://photo.8891.com.tw/2024/06/18/1718678880252227.png",
    title: "下載App 圖片縮放細節全掌握",
  },
  summary: {
    img: "https://photo.8891.com.tw/2024/06/18/1718678880203954.png",
    title: "下載App 找車更方便",
  },
};

const AppDownload: React.FC<any> = ({}) => {
  const [data, setData] = useState({
    img: "",
    title: "",
  });

  useEffect(() => {
    const isAppDownloadBox = Cookies.get("app-download-box");
    if (isAppDownloadBox === "1") {
      return;
    }
    if (location.pathname.includes("Article")) {
      setData(imgs.article);
    }
    if (location.pathname.includes("Picture")) {
      setData(imgs.picture);
    }
    if (location.pathname.includes("Summary")) {
      setData(imgs.summary);
    }
  }, []);
  return (
    <>
      {!!data.img && (
        <div
          id={"AppDownload"}
          className='w-226 h-300 fixed right-50 text-center pt-24 z-[110]'
          style={{ backgroundImage: `url(https://photo.8891.com.tw/2024/06/18/1718676552482046.png)`, bottom: 250 }}
        >
          <span className=''>下載App 隨時隨地看資訊</span>
          <img className='pt-10 w-124' src={data.img} />
          <div
            className='absolute bottom-0 right-100 w-24 h-24 cursor-pointer'
            onClick={() => {
              setData({ img: "", title: "" });
              Cookies.set("app-download-box", "1", { expires: 1 });
            }}
          ></div>
        </div>
      )}
    </>
  );
};

export default AppDownload;
